<template>
<div v-loading="exportLoading" element-loading-text="正在更新">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-button type="primary" @click="exportTable()">批量解绑</el-button>
            </el-form-item>
        </el-form>
    </el-col>
    <el-input type="textarea" :rows="20" placeholder="请粘贴要导出的卡号列表(每一条一行)" v-model="textarea" class="textexport">
    </el-input>
    <div style="color:red;">*批量解绑只能【临时解绑】，如需长期解绑需联系服务商解决</div>
</div>
</template>

<script>
import {
    bathsuspendCard
} from '../../api/api'
export default {
    data() {
        return {
            isUpload: true,
            url: '',
            textarea: '',
            exportLoading: false,
            status: "1"
        }

    },
    methods: {
        exportTable() {
            if (this.textarea.trim() == "") {
                this.$message({
                    message: '卡信息不能为空',
                    type: 'error'
                });
                return;
            }
            this.$confirm('确定要进行批量开机吗, 批量解绑只能【临时解绑】，如需长期解绑需联系服务商解决，是否继续?', '确认提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let para = {
                    cardinfo: this.textarea.trim(),
                    status: '1'
                }
                this.exportLoading = true;
                bathsuspendCard(para).then((res) => {
                    if (res.code == 0) {
                        this.url = res.data;
                        this.isUpload = true;
                        this.exportLoading = false;
                        this.textarea = res.msg;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.exportLoading = false;
                        this.isUpload = false;
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        }
    }
}
</script>  

<style>
.textexport {
    margin-top: 10px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// bathStarting.vue?8d1948f4